<template>
  <div class="step">
    <h2>Le tue credenziali</h2>
    <p class="subtitle text-medium">
      Digita le tue credenziali di accesso
    </p>
    <div class="fieldset">
      <p
        v-if="!emailChecker && params.email2 && params.email"
        class="text-small secondary"
      >
        Gli indirizzi email inseriti non coincidono
      </p>
      <Input
        v-if="preRegistration"
        v-model="params.email"
        type="email"
        :auto-focus="true"
        placeholder="Email"
        :regex="regex.email"
        :info-message="emailRegistrataMsg"
        @error="updateErrors"
        @callback="checkEmail"
      />
      <Input
        v-else
        v-model="params.email"
        type="email"
        :auto-focus="true"
        placeholder="Email"
        :regex="regex.email"
        @error="updateErrors"
      />
      <Input
        v-model="params.email2"
        type="email"
        placeholder="Ripeti email"
        :regex="regex.email"
        :paste="false"
        @error="updateErrors"
      />
      <p class="text-small">
        Il tuo indirizzo email sarà utile per accedere al tuo account e per
        ricevere comunicazioni da Sace.
      </p>
    </div>
    <div v-if="preRegistration" class="fieldset">
      <Input
        v-model="params.codicePartner"
        type="email"
        placeholder="Codice Partner"
        :regex="regex.partner"
        @error="updateErrors"
      />
    </div>
    <div v-if="!preRegistration" class="fieldset">
      <p
        v-if="!passwordChecker && params.password2 && params.password"
        class="text-small secondary"
      >
        Le password inserite non coincidono
      </p>
      <Input
        v-model="params.password"
        type="password"
        placeholder="password"
        :regex="regex.password"
        @error="updateErrors"
      />
      <Input
        v-model="params.password2"
        type="password"
        placeholder="Ripeti password"
        :regex="regex.password"
        :paste="false"
        @error="updateErrors"
      />
      <p class="text-small">
        Digita una password composta da minimo 9 caratteri, con almeno 3 dei
        seguenti requisiti: una lettera maiuscola, una lettera minuscola, una
        cifra numerica, un carattere speciale
      </p>
    </div>
    <div class="actions">
      <button
        v-if="!preRegistration"
        class="button primary"
        :disabled="disabled"
        @click="!disabled ? navigate('next') : null"
      >
        Avanti
      </button>
      <button
        v-else
        class="button primary"
        :disabled="disabled"
        @click="!disabled ? submit() : null"
      >
        Avanti
      </button>
      <button
        class="back"
        @click="navigate('prev')"
      >
        Torna indietro
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import { Paths } from '../../common/paths';

import Input from '../shared/InputComponent.vue';

Vue.use(VueLodash, { lodash });

const _ = require('lodash');

export default {
  name: 'Credenziali',
  components: {
    Input,
  },
  props: {
    preset: {
      type: Object,
      default: () => {},
    },
    preRegistration: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

      params: {
        email: null,
        email2: null,
        password: null,
        password2: null,
      },
      regex: {
        email: [
          {
            rule: /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9])+$/,
            msg: 'Formato non valido',
          },
          {
            rule: /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+((?!ai$)(?!AI$)[a-zA-Z0-9])+$/,
            msg: 'Estensione di dominio .ai non consentita',
          },
        ],
        password: [
          {
            rule: /(?=.{9,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/,
            msg: 'Formato non valido',
          },
        ],
        partner: [
          {
            rule: /^[a-zA-Z0-9]{7}$/,
            msg: 'Formato non valido',
          },
        ],
      },
      emailRegistrataMsg: null,
      errorsCounter: 0,
      canNextStep: false,
    };
  },
  computed: {
    emailChecker() {
      if (this.params.email2 && this.params.email) {
        return this.params.email2 === this.params.email;
      }
      return false;
    },
    passwordChecker() {
      if (this.params.password2 && this.params.password) {
        return this.params.password2 === this.params.password;
      }
      return false;
    },
    disabled() {
      const {
        emailChecker, passwordChecker, errorsCounter, params, canNextStep,
      } = this;
      const { email, password } = params;
      if (this.preRegistration) {
        return (!emailChecker || errorsCounter || !email || !canNextStep);
      }
      return (
        !emailChecker ||
        !passwordChecker ||
        errorsCounter ||
        !email ||
        !password
      );
    },
  },
  watch: {
    preset: {
      handler(v) {
        if (!_.isEmpty(v)) {
          this.params = v;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.preRegistration) {
      this.checkEmail(this.params.email);
    }
    this.$emit('push-event');
  },
  methods: {
    checkEmail(email) {
      if (email != null) {
        this.$root.showLoading(true);
        this.$http
          .post(Paths.preRegistrazione.checkEmail, {
            email,
          })
          .then(response => {
            if (response.data.code == 200) {
              this.emailRegistrataMsg = null;
              this.canNextStep = true;
            } else {
              this.emailRegistrataMsg = response.data.message;
              this.canNextStep = false;
            }
          })
          .catch(error => {
          })
          .finally(()=> {
            this.$root.showLoading(false);
          });
      }
    },
    navigate(step) {
      const obj = {
        params: this.params,
        step: 'credential',
        navigate: step,
      };
      this.$emit('navigate', obj);
    },
    updateErrors(error) {
      this.errorsCounter =
        this.errorsCounter > 0 && !error
          ? (this.errorsCounter -= 1)
          : (this.errorsCounter += 1);
    },
    submit() {
      const obj = {
        params: this.params,
        step: 'credential',
      };
      this.$emit('submit', obj);
    },
  },
};
</script>
